import { Box, Text, Card, Flex, Button, TextField, AlertDialog } from '@radix-ui/themes';
import { useState, useEffect } from 'react';
import { periodService } from '../../../services/teacher/periodService';
import { toast } from 'react-toastify';
import { DateTime } from 'luxon';
import LoadingIndicator from '../../shared/LoadingIndicator';

const CreatePeriod = ({ onClose, onSuccess }) => {
    const [defaultPeriods, setDefaultPeriods] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [formData, setFormData] = useState({
        academic_year: DateTime.now().year.toString(),
        title: '',
        start_date: '',
        end_date: '',
        source: 'personal'
    });

    useEffect(() => {
        getDefaultPeriods();
    }, []);

    const getDefaultPeriods = async () => {
        setLoading(true);
        try {
            const fetchedPeriods = await periodService.getDefaultPeriods();
            setDefaultPeriods(fetchedPeriods);
        } catch (error) {
            console.error('Error fetching default periods:', error);
            toast.error('Failed to fetch default periods');
        } finally {
            setLoading(false);
        }
    };

    const handleUseDefaultPeriod = (defaultPeriod) => {
        setFormData({
            academic_year: DateTime.now().year.toString(),
            title: defaultPeriod.title,
            start_date: DateTime.fromISO(defaultPeriod.start_date).toFormat('yyyy-MM-dd'),
            end_date: DateTime.fromISO(defaultPeriod.end_date).toFormat('yyyy-MM-dd'),
            source: 'default'
        });
        setShowForm(true);
    };

    const handleCreateCustom = () => {
        setFormData({
            academic_year: DateTime.now().year.toString(),
            title: '',
            start_date: '',
            end_date: '',
            source: 'personal'
        });
        setShowForm(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        console.log(formData)
        try {
            const period = await periodService.createPeriod(formData);
            console.log('CREATED PERIOD', period);
            toast.success('Period created successfully');
            onSuccess(period);
        } catch (error) {
            console.error('Error creating period:', error);
            toast.error('Failed to create period');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <LoadingIndicator />;
    }

    if (showForm) {
        return (
            <Box>
                <form onSubmit={handleSubmit}>
                    <Flex direction="column" gap="3">
                        <Box>
                            <Text as="label" size="2" mb="1">Academic Year Ends In</Text>
                            <TextField.Root
                                type="number"
                                value={formData.academic_year}
                                onChange={(e) => setFormData({ ...formData, academic_year: e.target.value })}
                                required
                            />
                        </Box>
                        <Box>
                            <Text as="label" size="2" mb="1">Title</Text>
                            <TextField.Root
                                type="text"
                                value={formData.title}
                                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                                required
                                placeholder="e.g., First Term 2024"
                            />
                        </Box>
                        <Box>
                            <Text as="label" size="2" mb="1">Start Date</Text>
                            <TextField.Root
                                type="date"
                                value={formData.start_date}
                                onChange={(e) => setFormData({ ...formData, start_date: e.target.value })}
                                required
                            />
                        </Box>
                        <Box>
                            <Text as="label" size="2" mb="1">End Date</Text>
                            <TextField.Root
                                type="date"
                                value={formData.end_date}
                                onChange={(e) => setFormData({ ...formData, end_date: e.target.value })}
                                required
                            />
                        </Box>
                        <Flex gap="3" mt="4" justify="end">
                            <Button
                                variant="soft"
                                color="gray"
                                onClick={() => setShowForm(false)}
                                disabled={loading}
                                type="button"
                            >
                                Back
                            </Button>
                            <Button
                                type="submit"
                                disabled={loading}
                            >
                                Create Period
                            </Button>
                        </Flex>
                    </Flex>
                </form>
            </Box>
        );
    }

    return (
        <Box>
            <Flex direction="column" gap="3">
                <Text size="3" weight="bold" mb="2">Default Periods</Text>
                {defaultPeriods.map((period) => (
                    <Card key={period.id}>
                        <Flex justify="between" align="center">
                            <Box>
                                <Text size="2" as="p" mb="0">{period.title}</Text>
                                <Text size="2" as="p" mb="0">Academic year ending in {period.academic_year}</Text>
                                <Text size="1" as="p" mb="0" weight="bold">
                                    {DateTime.fromISO(period.start_date).toLocaleString()} - {DateTime.fromISO(period.end_date).toLocaleString()}
                                </Text>
                            </Box>
                            <Button size="1" onClick={() => handleUseDefaultPeriod(period)}>
                                Use
                            </Button>
                        </Flex>
                    </Card>
                ))}

                <Button
                    mt="4"
                    onClick={handleCreateCustom}
                    variant="soft"
                >
                    Create Custom Period
                </Button>
            </Flex>
        </Box>
    );
};

export default CreatePeriod;
